var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import 'tippy.js/dist/tippy.css';
import { StyledTippy } from './styles';
const Popover = (_a) => {
    var { children, content, visible, onClickOutside, theme = 'light-border' } = _a, rest = __rest(_a, ["children", "content", "visible", "onClickOutside", "theme"]);
    useEffect(() => {
        require(`tippy.js/themes/${theme}.css`);
    });
    return (React.createElement(StyledTippy, Object.assign({ trigger: 'click', theme: theme, arrow: false, placement: 'bottom-end', content: content, interactive: true, visible: visible, onClickOutside: onClickOutside, offset: [0, 5] }, rest), children));
};
export { Popover, };
//# sourceMappingURL=Popover.js.map